const utils = {
  isIE() {
    const { userAgent } = window.navigator

    console.log(userAgent)

    if (userAgent.includes('Trident') || userAgent.includes('MSIE')) {
      return true
    }

    return false
  }
}

export default utils
